import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import { translate } from 'react-i18next';

import Display from '../../Display';
import { getLocationText } from '../../../utils/geo';
import { resetCurrentJourney } from './actions';
import { SidebarFooter } from '../SidebarFooter';

import ReactHighCharts from 'react-highcharts';
import Highcharts from 'highcharts';

const ReactHighstock = require('react-highcharts/ReactHighstock.src');
const Plot = ReactHighCharts.withHighcharts(Highcharts);

@translate(['single-ride-sidebar', 'dashboard', 'journey'], { wait: true })
class SingleRideSidebar extends Component {
  handleBack(e) {
    e.preventDefault();
    this.props.resetJourney(null);
  }

  render() {
    const { journey, t } = this.props;
    const accelerating = journey.scoring.accelerations.eventsCount;
    const braking = journey.scoring.brakings.eventsCount;
    const cornering = journey.scoring.cornerings.eventsCount;
    const speeding = journey.scoring.speedings.eventsCount;
    const journeyFuelConsumtion = journey.journey.stat.fuelConsumption;
    const journeyDistance = journey.journey.stat.distance;
    const journeyDuration = journey.journey.stat.duration;
    const hoursText = t('dashboard:hours');
    const daysText = t('dashboard:days');
    const minsText = t('dashboard:min');
    const kmText = t('dashboard:km');
    const lText = t('dashboard:l');
    const startTime = journey.journey.stat.startTime;
    let maxSpeed = { x: 0, y: 0 };
    const datas = journey.journey.events
      .map(e => {
        const time = parseFloat(
          ((e.occurrenceTime - startTime) / 60).toFixed(2),
        );
        const data = { y: e.maxSpeed, x: time };
        if (data.y > maxSpeed.y) {
          maxSpeed = data;
        }
        return data;
      })
      .sort((a, b) => a.x - b.x);

    const config = {
      credits: {
        enabled: false,
      },
      title: {
        text: '',
      },
      tooltip: {
        crosshairs: [
          {
            width: 1,
            dashStyle: 'solid',
            color: '#208ff6',
          },
          false,
        ],
        formatter() {
          // eslint-disable-line func-names
          let s = '';
          let color;
          const colorOpacity = 'rgba(178,178,178,0.2)';
          const colorNormal = 'rgba(178,178,178,1)';
          if (this.color !== colorOpacity) {
            color = this.color;
          } else {
            color = colorNormal;
          }
          s += `<div class="tooltipWrap comparison">
                <span class="titile">${this.x} ${t('dashboard:min')}</span>
                <span style="color:${color};">${parseInt(this.y)} ${t('journey:kmph')}</span>
               </div>`;
          return s;
        },
      },

      rangeSelector: {
        enabled: false,
      },

      navigator: {
        enabled: false,
      },

      plotOptions: {
        spline: {
          marker: { enabled: false },
          lineWidth: 2,
        },
        series: {
          states: {
            hover: { enabled: false },
          },
          turboThreshold: 0
        },
      },
      yAxis: {
        visible: false,
        title: false,
        gridLineColor: '#f6f6f6',
        min: 0,
      },
      xAxis: {
        labels: {
          formatter() {
            // eslint-disable-line func-names
            return this.value.toString();
          },
        },
      },
      series: [
        {
          type: 'spline',
          color: '#5bdb83',
          data: datas,
          name: 'Скорость',
          dataGrouping: {
            approximation: 'high',
          },
        },
        {
          type: 'flags',
          color: '#ffffff',
          data: [
            {
              title: `${maxSpeed.y} ${t('journey:kmph')}`,
              x: maxSpeed.x,
              y: maxSpeed.y,
            },
          ],
          onSeries: 'dataseries',
          shape: 'squarepin',
          width: 50,
        },
        {
          name: 'Custom symbol',
          data: [
            {
              x: maxSpeed.x,
              y: maxSpeed.y,
            },
          ],
          marker: {
            enabled: true,
            symbol: 'circle',
            radius: 5,
            lineColor: '#5bdb83',
            lineWidth: 2,
            fillColor: '#ffffff',
          },
        },
      ],
    };

    return (
      <aside className="aside">
        <div className="aside-scroll">
          <div className="map-events-list">
            <div
              className="map-events-list__item"
              data-progress={journey.scoring.score || 1}
            >
              <a
                onClick={e => this.handleBack(e)}
                className="map-events-list__back"
                href=""
              />
              <div className="map-events-list__item__holder">
                <span
                  className="progress-circle"
                  data-progress={journey.scoring.score}
                >
                  <span>
                    <em />
                  </span>
                  <span>
                    <em />
                  </span>
                </span>
                <div className="map-events-list__item__wrap">
                  <div className="map-events-list__item__address">
                    <div className="point">
                      <span>a</span>
                    </div>
                    <div className="holder">
                      {getLocationText(journey.geoData.start)}&nbsp;
                      <span className="time">
                        {moment(journey.journey.stat.startTime * 1000).format(
                          'HH:mm',
                        )}
                        <span />
                        {moment(journey.journey.stat.startTime * 1000).format(
                          'DD MMMM',
                        )}
                      </span>
                    </div>
                  </div>
                  <div className="map-events-list__item__address">
                    <div className="point">
                      <span>b</span>
                    </div>
                    <div className="holder">
                      {getLocationText(journey.geoData.finish)}&nbsp;
                      <span className="time">
                        <span>
                          {moment(
                            journey.journey.stat.finishTime * 1000,
                          ).format('HH:mm')}
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="aside-map-events">
            <Display isShown={!!speeding}>
              <div className="aside-map-events__row map-events__row-speeding">
                <div className="title">{t('single-ride-sidebar:speeding')}</div>
                <div className="holder">
                  <span>{speeding}</span>
                </div>
              </div>
            </Display>
            <Display isShown={!!accelerating}>
              <div className="aside-map-events__row map-events__row-acceleration">
                <div className="title">
                  {t('single-ride-sidebar:accelerating')}
                </div>
                <div className="holder">
                  <span>{accelerating}</span>
                </div>
              </div>
            </Display>
            <Display isShown={!!cornering}>
              <div className="aside-map-events__row map-events__row-maneuvers">
                <div className="title">
                  {t('single-ride-sidebar:cornering')}
                </div>
                <div className="holder">
                  <span>{cornering}</span>
                </div>
              </div>
            </Display>
            <Display isShown={!!braking}>
              <div className="aside-map-events__row map-events__row-braking">
                <div className="title">{t('single-ride-sidebar:braking')}</div>
                <div className="holder">
                  <span>{braking}</span>
                </div>
              </div>
            </Display>
          </div>
          <div className="avg_speed">
            <div className="avg_speed_num">
              {journey.journey.stat.avgSpeed} {t('journey:kmph')}
              <div className="avg_speed_sub">{t('journey:avg_speed')}</div>
            </div>
          </div>
          <ReactHighstock
            config={config}
            domProps={{
              id: 'sectionGraphDrivingTime_sb',
              className: 'graph-section__graph_sb',
            }}
          />
          <div className="aside-map-events-statistics">
          <Display isShown={!!journeyDuration}>
              <div className="box">
                <div className="num">
                  {moment
                    .duration(journeyDuration, 'seconds')
                    .format(`d [${daysText}] h [${hoursText}] m [${minsText}]`)}
                </div>
                <div className="title">{t('single-ride-sidebar:time')}</div>
              </div>
            </Display>
            <Display isShown={!!journeyDistance}>
              <div className="box">
                <div className="num">
                  {Math.round(journeyDistance / 1000 * 10) / 10}{' '}
                  {kmText}
                </div>
                <div className="title">{t('single-ride-sidebar:distance')}</div>
              </div>
            </Display>
            <Display isShown={!!journeyFuelConsumtion}> 
              <div className="box">
                <div className="num">
                  {(journeyFuelConsumtion / 100).toFixed(1)}{' '}
                  {lText}
                </div>
                <div className="title">{t('single-ride-sidebar:fuel')}</div>
              </div>
            </Display>
          </div>
        </div>
        <SidebarFooter />
      </aside>
    );
  }
}

SingleRideSidebar.propTypes = {
  journey: PropTypes.object,
  resetJourney: PropTypes.func,
  isShown: PropTypes.bool,
};

export default connect(
  state => ({
    journey: state.rides.currentJourney,
    currentLanguage: state.langs.currentLanguage,
  }),
  dispatch => ({
    resetJourney(journey) {
      return dispatch(resetCurrentJourney(journey));
    },
  }),
)(SingleRideSidebar);



// WEBPACK FOOTER //
// ./src/components/Sidebar/RidesSidebar/SingleRideSidebar.js